/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const EXPENSE_BASE_LINK = '/admin/expenses'
const REVENUE_BASE_LINK = '/admin/revenues'

export function getTransactionCreateLink (expense: boolean, params?: Record<string, unknown>) {
  return expense
    ? `${EXPENSE_BASE_LINK}/create?${stringify({ ...params, expense })}`
    : `${REVENUE_BASE_LINK}/create?${stringify({ ...params, expense })}`
}

export function getTransactionLink (id: number, expense: boolean) {
  return expense
    ? `${EXPENSE_BASE_LINK}/${id}/edit`
    : `${REVENUE_BASE_LINK}/${id}/edit`
}

export function getTransactionListLink (expense: boolean) {
  return `${expense ? EXPENSE_BASE_LINK : REVENUE_BASE_LINK}`
}
